import { render } from "./admin-header.vue?vue&type=template&id=62b4012a"
import script from "./admin-header.vue?vue&type=script&lang=js"
export * from "./admin-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__